/**
 * Сколько осталось до удаления учётной записи, с точностью до секунды.
 *
 * Тикает сам по себе: панель держат открытой, и застывшее «через 3 часа»
 * через час уже врёт.
 */
import { useEffect, useState } from "react";
import { Tag, Tooltip } from "antd";
import dayjs from "dayjs";

function left(until: string): string {
  const ms = Math.max(0, new Date(until).getTime() - Date.now());
  const total = Math.floor(ms / 1000);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${hours}:${pad(minutes)}:${pad(seconds)}`;
}

export function DeletionCountdown({ until }: { until: string }) {
  const [text, setText] = useState(() => left(until));

  useEffect(() => {
    const timer = window.setInterval(() => setText(left(until)), 1000);
    return () => window.clearInterval(timer);
  }, [until]);

  return (
    <Tooltip title={`Удаление назначено на ${dayjs(until).format("D MMMM, HH:mm:ss")}. Владелец может войти и отменить его.`}>
      <Tag color="orange">Удаление через {text}</Tag>
    </Tooltip>
  );
}
